import { Component } from "preact";
import PropTypes from "prop-types";
import { APIConnector, ArrayUtils, Calc, combineClasses, get, Jiffy, SortRules } from "@green24/npm-javascript-utils";
import ButtonsConstructor from "../../../components/shared/Input/Button/ButtonsConstructor";
import ErrorBlock from "../../../components/shared/ErrorBlock";
import Interpret from "../../../components/shared/Localization/Interpret";
import Fa from "../../../components/shared/Fa";
import ValueWithUnit from "../../../components/shared/ValueWithUnit";
import { E_Format_Unit } from "../../../models/constants/Enums_FormatUtils";
import { E_Route } from "../../../models/constants/Enum_Routes";
import { StorageUtils } from "../../../utils/StorageUtils";
import { locationServices } from "../../../services/location-services";
import Loading from "../../../components/shared/Loading";
import BoxTerminal from "../../../components/shared/BoxTerminal";
import { E_DeliveryWizard_Section } from "../../../models/constants/Enums_DeliveryWizard";

class RentWizardBoxType extends Component {
	constructor(props) {
		super();

		this.state = {
			loading: true,
			error: null,
			serviceTypes: [],
			selectedServiceType: props.selectedServiceType,
		}
	}

	componentDidMount() {
		this._refresh();
	}

	_renderDimensions(dimensionsDetail) {
		if(dimensionsDetail.x && dimensionsDetail.y && dimensionsDetail.z) {
			return (
				<div className={"graphics"}>
					<Fa icon={"cube-light"}/>

					<div className={"dimension dimension-x"}>
						<ValueWithUnit className={"cm"} value={Calc.round(dimensionsDetail.x / 10, 2)} unit={E_Format_Unit.CENTIMETER}/>
					</div>

					<div className={"dimension dimension-y"}>
						<ValueWithUnit className={"cm"} value={Calc.round(dimensionsDetail.y / 10, 2)} unit={E_Format_Unit.CENTIMETER}/>
					</div>

					<div className={"dimension dimension-z"}>
						<ValueWithUnit className={"cm"} value={Calc.round(dimensionsDetail.z / 10, 2)} unit={E_Format_Unit.CENTIMETER}/>
					</div>
				</div>
			)
		}

		return (
			<div className={"dimensions-text"}>
				<Interpret id={dimensionsDetail.dimensionsText}/>
			</div>
		);
	}

	_renderServiceTypeContent(serviceType) {
		if(!serviceType) return null;

		return (
			<div className={"service-type"}>
				<div className={"dimensions"}>
					{this._renderDimensions(serviceType.dimensionsDetail)}
				</div>
			</div>
		)
	}

	_renderContent() {
		const {onContinue} = this.props;
		const {loading, error, selectedServiceType, serviceTypes} = this.state;

		if(loading) {
			return <Loading block={true}/>
		}

		if(error) {
			return <ErrorBlock error={error}/>
		}

		serviceTypes.sort(SortRules.idAsc);

		return (
			<>
				<BoxTerminal
					title={"box.deliverPackage"}
					contentHeaderSlot={
						<div className={"title"}>
							<Interpret id={"selectBox"}/>
						</div>
					}
					contentLeftSlot={
						this._renderServiceTypeContent(ArrayUtils.findByID(serviceTypes, selectedServiceType?.id))
					}
					contentSlot={
						<div className={"selector"}>
							<ButtonsConstructor buttons={serviceTypes.map(serviceType => {
								return {
									text: serviceType.titles,
									action: () => this.setState({selectedServiceType: serviceType}),
									active: serviceType.id == selectedServiceType?.id,
								}
							})}/>
						</div>
					}
				/>

				<nav className={"action-buttons"}>
					<ButtonsConstructor buttons={[
						{
							text: "continue",
							disabled: !selectedServiceType,
							action: () => onContinue(selectedServiceType),
							className: "continue-button"
						}
					]}/>
				</nav>
			</>
		)
	}

	render({className, style}) {
		return (
			<section className={combineClasses("rent-wizard-box-type", className)} style={style}>
				{this._renderContent()}
			</section>
		);
	}

	_refresh() {
		const {locationID, unitID, partnerID} = this.props;

		this.setState({
			loading: true,
			error: null,
		});
		locationServices.getItem(locationID, partnerID).then(location => {
			this.setState({
				serviceTypes: location.availableServiceTypes,
			})
		}, error => {
			this.setState({error});
		}).finally(() => {
			this.setState({loading: false});
		});
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			locationID: PropTypes.number.isRequired,
			selectedServiceType: PropTypes.object,

			onContinue: PropTypes.func.isRequired,
		}
	}

	static get stateTypes() {
		return {
			loading: PropTypes.bool,
			error: PropTypes.object,
			selectedServiceType: PropTypes.object,
			serviceTypes: PropTypes.array,
		}
	}
}

export default RentWizardBoxType;
